import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ModulePermission,
  ModulePermissionsState,
} from "../../models/interfaces/modulePermissions";

const initialState: ModulePermissionsState = {
  permissions: {},
};

const modulePermissionsSlice = createSlice({
  name: "modulePermissions",
  initialState,
  reducers: {
    setModulePermission: (
      state,
      action: PayloadAction<{
        moduleUUID: string;
        hasAccess: boolean;
        isLoading?: boolean;
      }>
    ) => {
      const { moduleUUID, hasAccess, isLoading = false } = action.payload;
      state.permissions[moduleUUID] = {
        moduleUUID,
        hasAccess,
        isLoading,
        lastChecked: Date.now(),
      };
    },
    setModulePermissionLoading: (
      state,
      action: PayloadAction<{ moduleUUID: string; isLoading: boolean }>
    ) => {
      const { moduleUUID, isLoading } = action.payload;
      if (state.permissions[moduleUUID]) {
        state.permissions[moduleUUID].isLoading = isLoading;
      }
    },
    clearModulePermissions: (state) => {
      state.permissions = {};
    },
  },
});

export const {
  setModulePermission,
  setModulePermissionLoading,
  clearModulePermissions,
} = modulePermissionsSlice.actions;
export default modulePermissionsSlice.reducer;
